// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/QuestionFormAnswer.test.tsx
import { Button, Text } from "@radix-ui/themes";
import cx from "classnames";
import { useTranslation } from "react-i18next";

/**
 * Figma QuestionFormAnswer 49858:1755 — compact answer chip with Undo.
 * why: not the full QuestionForm completed shell; onboarding/confirm uses this denser row.
 */
export function QuestionFormAnswer({
  answer,
  onUndo,
  className,
  "data-testid": dataTestId = "question-form-answer",
}: {
  answer: string;
  onUndo?: () => void;
  className?: string;
  "data-testid"?: string;
}) {
  const { t } = useTranslation("ui");
  const undoLabel = t("questionForm.undo");

  return (
    <div
      data-testid={dataTestId}
      aria-label={answer}
      className={cx(
        // why: completed chip fills the chat/composer parent — no fixed max width.
        "flex w-full items-center justify-between gap-3 rounded-xl border border-puntt-neutral-gray-4 bg-base-white px-4 py-2.5",
        className,
      )}
    >
      <Text
        size="2"
        weight="medium"
        className="min-w-0 truncate text-puntt-neutral-gray-11"
        data-testid={`${dataTestId}-label`}
      >
        {answer}
      </Text>
      {onUndo ? (
        <Button
          type="button"
          data-testid={`${dataTestId}-undo`}
          aria-label={undoLabel}
          size="1"
          variant="ghost"
          className="shrink-0"
          onClick={onUndo}
        >
          {undoLabel}
        </Button>
      ) : null}
    </div>
  );
}
